// NPM Imports
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Loader, Button } from "@revvsales/components";

// Components Imports
import { GlobalUtils } from "../../../../utils";

export default function GlobalTemplatesList(props) {
  // * LOCAL STATE DECLARATION SYNTAX

  const { truncateString } = GlobalUtils;
  const INITIAL_STATE = {
    imgLoading: true,
    showPreviewBtn: false,
  };
  const [state, setState] = useState(INITIAL_STATE);
  const { data, index } = props;

  const _handleImgLoading = () => {
    setState(Object.assign({}, state, { imgLoading: false }));
  };
  return (
    <div
      className="globaltemplateslist-wrapper"
      onFocus={() =>
        setState(Object.assign({}, state, { showPreviewBtn: true }))
      }
      onBlur={() =>
        setState(Object.assign({}, state, { showPreviewBtn: false }))
      }
      onMouseEnter={() =>
        setState(Object.assign({}, state, { showPreviewBtn: true }))
      }
      onMouseLeave={() =>
        setState(Object.assign({}, state, { showPreviewBtn: false }))
      }
      onClick={() => props.previewOpen(index)}
      onKeyPress={e => (e.which === 13 ? props.previewOpen(index) : null)}
      role="button"
      tabIndex={0}>
      <div className="globaltemplateslist-thumbnail-section">
        {state.imgLoading && <Loader />}
        <img
          src={data.thumbnail}
          alt="doc-thumbnails"
          className="globaltemplateslist-img"
          onLoad={() => _handleImgLoading()}
        />
        {state.showPreviewBtn && (
          <Button
            tabIndex="-1"
            className="globaltemplateslist-btn"
            data-test="globaltemplateslist-preview-btn">
            Preview
          </Button>
        )}
      </div>
      <div className="globaltemplateslist-title">{data.title}</div>
      <div className="globaltemplateslist-description">
        <div>
          {data.description
            ? truncateString(data.description, 130, true)
            : null}
        </div>
      </div>
    </div>
  );
}

GlobalTemplatesList.propTypes = {
  data: PropTypes.shape({
    description: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  previewOpen: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/TemplateV2/GlobalTemplates/GlobalTemplatesList/index.js